import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { useApi } from "@/hooks/useApi";
import { api, errMsg } from "@/lib/api";
import { fmtDateTime, ATTENDANCE_STATUS } from "@/lib/format";

const STATUSES = ["hadir", "izin", "sakit", "alpa"];

export default function AttendanceDialog({ cls, onClose }) {
  const { data, loading, reload } = useApi(`/admin/classes/${cls.id}/attendance`);
  const mark = async (user_id, status) => {
    try {
      await api.put(`/admin/classes/${cls.id}/attendance`, { user_id, status });
      reload();
    } catch (e) {
      toast.error(errMsg(e));
    }
  };
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-2xl max-h-[85vh] overflow-y-auto" data-testid="attendance-dialog">
        <DialogHeader><DialogTitle className="font-display">Absensi · {cls.title}</DialogTitle></DialogHeader>
        <p className="text-sm text-slate-500 -mt-2">{fmtDateTime(cls.start_at)}</p>
        {loading && !data ? <Loader2 className="h-5 w-5 animate-spin text-amber-500" /> : data?.students.length === 0 ? (
          <p className="text-sm text-slate-500">Belum ada siswa aktif untuk kelas ini.</p>
        ) : (
          <ul className="divide-y divide-slate-100">
            {data.students.map((s) => (
              <li key={s.id} className="py-3 flex flex-wrap items-center justify-between gap-3" data-testid={`attendance-student-${s.id}`}>
                <div><p className="font-medium text-sm">{s.name}</p><p className="text-xs text-slate-500">{s.email}</p></div>
                <div className="flex gap-1">
                  {STATUSES.map((st) => (
                    <button key={st} onClick={() => mark(s.id, st)} className={`px-2.5 py-1 rounded border text-xs font-semibold capitalize ${s.status === st ? ATTENDANCE_STATUS[st] : "border-slate-200 text-slate-500 hover:bg-slate-50"}`} data-testid={`attendance-mark-${s.id}-${st}`}>{st}</button>
                  ))}
                </div>
              </li>
            ))}
          </ul>
        )}
      </DialogContent>
    </Dialog>
  );
}
